import { useState } from "react";
import env from "../../../../../config";

const OAUTH_URL = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.APP_URL}/integrations%2Fsupport&client_id=69452594b480b1848b1bf78d-mjcpz80c&scope=conversations.readonly+conversations.write+conversations%2Fmessage.readonly+conversations%2Fmessage.write+conversations%2Flivechat.write+contacts.readonly+contacts.write+locations%2FcustomFields.readonly+locations%2FcustomFields.write&version_id=69452594b480b1848b1bf78d`;

const LocationConnectModal = () => {
  const [open, setOpen] = useState(false);

  const handleConnect = () => {
    window.open(OAUTH_URL, "_blank", "noopener,noreferrer");
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      <button
        className="btn btn-secondary btn-lg px-5 d-inline-flex align-items-center"
        onClick={handleConnect}
      >
        <i className="bi bi-plus-circle me-2"></i>
        Connect Location Now
      </button>

      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(15, 23, 42, 0.6)", zIndex: 2000 }}
          onClick={(e) => {
            if (e.target === e.currentTarget) handleClose();
          }}
        >
          <style>{`
            .connect-guide-modal .modal-content {
              border-radius: 14px;
              overflow: hidden;
            }
            .connect-guide-modal .step-pill {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              font-weight: 600;
              font-size: 13px;
              flex-shrink: 0;
              background: #e7f1ff;
              color: #0d6efd;
            }
            .connect-guide-modal .step-row {
              display: flex;
              gap: 12px;
              align-items: flex-start;
              padding: 10px 0;
            }
            .connect-guide-modal .pulse-icon {
              width: 72px;
              height: 72px;
              border-radius: 50%;
              background: linear-gradient(135deg, #e7f1ff, #cfe2ff);
              display: inline-flex;
              align-items: center;
              justify-content: center;
              color: #0d6efd;
              animation: pulse-soft 2.2s ease-in-out infinite;
              margin-bottom: 14px;
            }
            @keyframes pulse-soft {
              0%, 100% { box-shadow: 0 0 0 0 rgba(13,110,253,0.25); }
              50%      { box-shadow: 0 0 0 12px rgba(13,110,253,0); }
            }
          `}</style>
          <div className="modal-dialog modal-dialog-centered connect-guide-modal">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title fw-bold mb-0 d-flex align-items-center gap-2">
                  <i
                    className="bi bi-link-45deg text-primary"
                    style={{ fontSize: 22 }}
                  ></i>
                  Connecting Your Location
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>

              <div className="modal-body pt-3 text-center">
                <div className="pulse-icon">
                  <i className="bi bi-arrow-repeat" style={{ fontSize: 30 }}></i>
                </div>
                <h6 className="fw-semibold mb-2">
                  Integration in progress in a new tab
                </h6>
                <p className="text-muted small mb-4 px-2">
                  We&rsquo;ve opened GoHighLevel in a new browser tab. Choose the
                  location you&rsquo;d like to connect and authorize the
                  required permissions there.
                </p>

                <div className="text-start px-2">
                  <div className="step-row">
                    <span className="step-pill">1</span>
                    <div className="small">
                      Switch to the newly opened tab and select your{" "}
                      <strong>location</strong>.
                    </div>
                  </div>
                  <div className="step-row">
                    <span className="step-pill">2</span>
                    <div className="small">
                      Approve the requested permissions to allow Support App
                      access.
                    </div>
                  </div>
                  <div className="step-row">
                    <span className="step-pill">3</span>
                    <div className="small">
                      Once GoHighLevel confirms the connection, return to this
                      tab and{" "}
                      <strong>refresh the page</strong> to start using the
                      Support App features.
                    </div>
                  </div>
                </div>

                <div
                  className="mt-3 p-3 rounded-3 d-flex align-items-start gap-2"
                  style={{
                    background: "#fff8e1",
                    border: "1px solid #ffe69c",
                    color: "#664d03",
                    fontSize: "0.85rem",
                    textAlign: "left",
                  }}
                >
                  <i
                    className="bi bi-info-circle-fill mt-1"
                    style={{ color: "#f59f00" }}
                  ></i>
                  <span>
                    Don&rsquo;t close this window. After authorization completes
                    in the other tab, click <strong>Refresh Page</strong>{" "}
                    below to load your connected location.
                  </span>
                </div>
              </div>

              <div className="modal-footer border-0 pt-0 d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4 d-inline-flex align-items-center gap-2"
                  onClick={handleRefresh}
                >
                  <i className="bi bi-arrow-clockwise"></i>
                  Refresh Page
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LocationConnectModal;
